const mobileToggleButtons = document.querySelectorAll('[data-mobile-toggle]');

[...mobileToggleButtons].forEach((button) => {
    button.addEventListener('click', () => {
        document.querySelector('body').classList.toggle('mobile-navigation-active');
    });
});



// WEBPACK FOOTER //
// ./resources/components/header/mobile-navigation.js